export default "__VITE_ASSET__EQV$uLvU__"